import { render, staticRenderFns } from "./AuthorizedForm.vue?vue&type=template&id=39df65ac&scoped=true&"
import script from "./AuthorizedForm.vue?vue&type=script&lang=js&"
export * from "./AuthorizedForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizedForm.vue?vue&type=style&index=0&id=39df65ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39df65ac",
  null
  
)

export default component.exports